import { MapStyleId } from "../types";

export interface MapStyleInfo {
  id: MapStyleId;
  name: string;
  desc: string;
  icon: string;
  free: boolean;
  starred?: boolean;
}

export const FREE_STYLES: MapStyleInfo[] = [
  {
    id: "esri:satellite",
    name: "Satellite",
    desc: "Aerial imagery",
    icon: "🌍",
    free: true,
    starred: true,
  },
  {
    id: "osm:standard",
    name: "OpenStreetMap",
    desc: "Standard OSM",
    icon: "🗺️",
    free: true,
    starred: true,
  },
  {
    id: "osm:humanitarian",
    name: "Humanitarian",
    desc: "Crisis mapping",
    icon: "🚑",
    free: true,
  },
  {
    id: "osm:topographic",
    name: "Topographic",
    desc: "Elevation lines",
    icon: "⛰️",
    free: true,
  },
  {
    id: "cartodb:light",
    name: "Light",
    desc: "Clean minimal style",
    icon: "☀️",
    free: true,
  },
  {
    id: "cartodb:dark",
    name: "Dark",
    desc: "Dark theme style",
    icon: "🌙",
    free: true,
    starred: true,
  },
  {
    id: "cartodb:voyager",
    name: "Voyager",
    desc: "High contrast colors",
    icon: "🚀",
    free: true,
  },
  {
    id: "esri:gray",
    name: "Gray Canvas",
    desc: "High contrast grayscale",
    icon: "🔳",
    free: true,
  },
];

export const THUNDERFOREST_STYLES: MapStyleInfo[] = [
  {
    id: "thunderforest:cycle",
    name: "Cycle",
    desc: "Cycling routes",
    icon: "🚴",
    free: false,
    starred: true,
  },
  {
    id: "thunderforest:landscape",
    name: "Landscape",
    desc: "Terrain focus",
    icon: "🏔️",
    free: false,
  },
  {
    id: "thunderforest:outdoors",
    name: "Outdoors",
    desc: "Hiking trails",
    icon: "🥾",
    free: false,
    starred: true,
  },
  {
    id: "thunderforest:transport",
    name: "Transport",
    desc: "Public transit",
    icon: "🚇",
    free: false,
  },
  {
    id: "thunderforest:transport-dark",
    name: "Transport Dark",
    desc: "Night transit",
    icon: "🌃",
    free: false,
  },
  {
    id: "thunderforest:spinal-map",
    name: "Spinal Map",
    desc: "Abstract style",
    icon: "🎨",
    free: false,
  },
  {
    id: "thunderforest:pioneer",
    name: "Pioneer",
    desc: "Classic style",
    icon: "🗺️",
    free: false,
  },
  {
    id: "thunderforest:mobile-atlas",
    name: "Mobile Atlas",
    desc: "Mobile optimized",
    icon: "📱",
    free: false,
  },
  {
    id: "thunderforest:neighbourhood",
    name: "Neighbourhood",
    desc: "Local detail",
    icon: "🏘️",
    free: false,
  },
];

export const ALL_STYLES = [...FREE_STYLES, ...THUNDERFOREST_STYLES];

export const STARRED_STYLES = ALL_STYLES.filter((s) => s.starred);

// Helper function to get style info by ID
export function getMapStyleInfo(styleId: string): MapStyleInfo | undefined {
  return ALL_STYLES.find((style) => style.id === styleId);
}
